export enum AnprOperation {
  Unauthorized = '0',
  ReadOnlyMilan = '1',
  ReadOnlyNational = '2',
  CertificationAnpr = '3',
  ReadOnlyMilanCertificationAnpr = '4',
  ReadOnlyNationalCertificationAnpr = '5',
}

export type AuthorizationsList = {
  id: string;
  type: string;
  value: string;
};

export type Feature = {
  codeInstitutionOperator?: string; // new
  authNote?: string;
  authPaternitaMaternita?: string;
  authFirmaCertificati?: string;
  authNomiStorici?: string;
  authStampaResidentiPerCivico?: string;
  controlloDiCassa?: string;
  diffida?: string;
  capoServizio?: string;
  registrazioneNoteBloccoEspatrio?: string;
  statoCivile?: string;
  elettorale?: string;
  stampaSAP?: string;
  sipoWeb?: string;
  eventi?: string;
  displayStatoCivile?: string;
  DisplayPensioni?: string;
  displayStoriaMatrimoni?: string;
  displayCittadinanze?: string;
  feature18?: string;
  visualizzaStoriaIndirizzi?: string;
  visualizzaDocumenti?: string;
  visualizzaFamiglia?: string;
  visuallizzaProfessTitStudio?: string;
  visualizzaRapportoParentela?: string;
  ListaOmonimi?: string;
  blocco99?: string;
  operatoreEsterno?: string;
  storiaIscrizioniCancellazioni?: string;
  praticheCensimento?: string;
  anpr?: AnprOperation;
  cartellinoCID?: string;
  senzaFissaDimora?: string;
  sistema?: string;
  filtroPraticaServizioOperatore?: string;
  authorizationsList?: AuthorizationsList[];
  visualizzaFascicoloCittadino?: string;
  visualizzaAltriDati?: string;
  visualizzaAbilitaModifiche?: string;
  gestioneGeografiche?: string;
  gestioneToponomastica?: string;
  modificaTestoEvento?: string;
};
